import { render, staticRenderFns } from "./ProductPageTheme1.vue?vue&type=template&id=639cc6e4&scoped=true"
import script from "./ProductPageTheme1.vue?vue&type=script&lang=js"
export * from "./ProductPageTheme1.vue?vue&type=script&lang=js"
import style0 from "./ProductPageTheme1.vue?vue&type=style&index=0&id=639cc6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639cc6e4",
  null
  
)

export default component.exports